import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormItem, FormOption } from '../form/FormItem';
import { FormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'vias-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() onchange: EventEmitter<object> = new EventEmitter<object>();
  constructor() {}
  ngOnInit(): void {
  }
  onChange($event: MatSelectChange): void {
    if (this.item.toggleFormItems !== undefined && this.item.toggleOffValues !== undefined) {
      this.item.toggleOffValues.forEach( item => {
        if (item.data === $event.value){
          this.item.toggleFormItems.forEach(tItemName => this.toggleItem(tItemName, true) );
        }else{
          this.item.toggleFormItems.forEach(tItemName => this.toggleItem(tItemName, false) );
        }
      });
    }
    this.onchange.emit($event.value);
  }
  toggleItem(tItemName: string, disable: boolean): void{
    if (disable) {
      this.form.controls[tItemName].disable();
    } else {
      this.form.controls[tItemName].enable();
    }
  }
}
